module.exports = __webpack_public_path__ + "img/Chevron-Plain-Right.40666c04.svg";